module.exports = __webpack_public_path__ + "static/media/settings-white.dd9dc4f1.svg";